import React, { useEffect } from 'react';
import gql from 'graphql-tag';
import { useLocation, useHistory } from 'react-router-dom';
import { useLazyQuery } from '@apollo/react-hooks';

import ResultsTable from '../components/titleManagement/ResultsTable';
import Loading from '../components/Loading';
import { useQueryString } from './titleManagement/AudiobookDetail';
import SEO from '../components/seo';
import Layout from '../components/Layout';
import { GET_SPOTIFY_URI } from '../queries';
import { isShowURI } from '../utils';

const CUBE_SUMMARY = gql`
    query CubeQuery($q: String!, $limit: Int, $after: String, $before: String) {
        cubeQuery(q: $q, limit: $limit, after: $after, before: $before) {
            paging {
                total_count
                before
                after
            }
            results {
                _id
                active
                contentId
                title
                subtitle
                publisherName
                publisherDisplayName
                contributors {
                    authors {
                        fullName
                    }
                    narrators {
                        fullName
                    }
                }
            }
        }
    }
`;

const SearchableTable = () => {
    const [cubeSummaryQuery, { loading, data, fetchMore }] = useLazyQuery(CUBE_SUMMARY);
    const [spotifyURIQuery, { data: spotifyData }] = useLazyQuery(GET_SPOTIFY_URI);
    const location = useLocation();
    const history = useHistory();
    const query = useQueryString(location.search);
    const term = query.get('q');

    const handleNext = (e) => {
        e.preventDefault();
        fetchMore({
            variables: {
                q: term,
                after: data.cubeQuery.paging.after
            },
            updateQuery: (prev, { fetchMoreResult }) => fetchMoreResult
        });
    };

    const handlePrev = (e) => {
        e.preventDefault();
        // setAfter(null);
        fetchMore({
            variables: {
                q: term,
                before: data.cubeQuery.paging.before
            },
            updateQuery: (prev, { fetchMoreResult }) => fetchMoreResult
        });
    };

    useEffect(() => {
        let getQuery = async () => {
            await spotifyURIQuery({
                variables: { id: term },
                skip: !isShowURI(term)
            });

            if (spotifyData?.findagatewayMapping) {
                history.push(`/title-management/${spotifyData?.findagatewayMapping}`);
                return;
            }

            await cubeSummaryQuery({
                variables: { q: term, limit: 10 }
            });

            if (data?.cubeQuery?.results?.length === 1) {
                history.push(`/title-management/${data?.cubeQuery?.results[0].contentId}`);
            }
        };

        getQuery();
    }, [term, cubeSummaryQuery, data, history, spotifyURIQuery, spotifyData]);

    let results = data?.cubeQuery?.results || [];

    return (
        <Layout>
            <SEO title={term && !!results.length ? `Showing Results for "${term}"` : 'Search Cube'} />
            {loading && <Loading />}
            {!!results.length && results.length > 1 && <ResultsTable results={results} />}
            {data?.cubeQuery?.paging && (
                <div className="txt-center py-5">
                    <div className="btn-group">
                        {data.cubeQuery.paging.before && (
                            <button className="btn btn-outline-primary" onClick={handlePrev}>
                                Prev
                            </button>
                        )}
                        {data.cubeQuery.paging.after && (
                            <button className="btn btn-outline-primary" onClick={handleNext}>
                                Next
                            </button>
                        )}
                    </div>
                </div>
            )}
            {!loading && !results.length && term && <p className="lead txt-center">No Results</p>}
        </Layout>
    );
};

export default SearchableTable;
